import React from 'react';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect } from 'react-router-dom';
import EditMetrics from './components/EditMetrics';
import EditMetricsTestHarness from './components/EditMetricsTestHarness';
import ViewHealthData from './components/ViewHealthData';
import ViewHealthDataTestHarness from './components/ViewHealthDataTestHarness';
import AIChat from './components/AIChat';
import AIChatTestHarness from './components/AIChatTestHarness';
import MedicalDataViewer from './components/MedicalDataViewer';
import MedicalDataViewerTestHarness from './components/MedicalDataViewerTestHarness';
import PreventCalculator from './components/PreventCalculator';
import PreventCalculatorTestHarness from './components/PreventCalculatorTestHarness';
import ExercisePlan from './components/ExercisePlan';
import LifestyleTools from './components/LifestyleTools';
import LifestyleToolsTestHarness from './components/LifestyleToolsTestHarness';
import MedicalNotesParkingLot from './components/MedicalNotesParkingLot';
import MedicalNotesParkingLotTestHarness from './components/MedicalNotesParkingLotTestHarness';
import HMSHome from './components/HMSHome';
import HMSHomeTestHarness from './components/HMSHomeTestHarness';
import PIIWasher from './components/PIIWasher';
import PIIWasherTestHarness from './components/PIIWasherTestHarness';
import logo from './logo.svg';
import './App.css';



const Home = () => (
  <div className="App">
    <header className="App-header">
      <img src={logo} className="App-logo" alt="logo" />
      <p>
        HMS - Health Management System
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
        <a className="App-link" href="/edit-metrics">Edit Metrics</a>
        <a className="App-link" href="/view-health-data">View Health Data</a>
        <a className="App-link" href="/ai-chat">AI Chat</a>
        <a className="App-link" href="/medical-data-viewer">Medical Data Viewer</a>
        <a className="App-link" href="/prevent">PREVENT Calculator</a> 
        <a className="App-link" href="/medical-data-viewer-test-harness">Medical Data Viewer Test</a>
        <a className="App-link" href="/prevent-test-harness">PREVENT Calculator Test</a>
        <a className="App-link" href="/lifestyle-tools-test-harness">Lifestyle Tools Test</a>
        <a className="App-link" href="/medical-notes-parking-lot-test-harness">Medical Notes Parking Lot Test</a> 
        <a className="App-link" href="/hms-home-test-harness">HMS Home Test</a>
        <a className="App-link" href="/pii-washer">PII Washer</a>
        <a className="App-link" href="/pii-washer-test-harness">PII Washer Test</a>
      </div>
    </header>
  </div>
);

function App() {
  return (
    <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          <Route path="/" exact render={() => <Home />} />
          <Route path="/edit-metrics" exact render={() => <EditMetrics />} />
          <Route path="/view-health-data" exact render={() => <ViewHealthData />} />
          <Route path="/ai-chat" exact render={() => <AIChat />} />
          <Route path="/medical-data-viewer" exact render={() => <MedicalDataViewer />} />
          <Route path="/prevent" exact render={() => <PreventCalculator />} />
          <Route path="/exercise-plan" exact render={() => <ExercisePlan />} />
          <Route path="/lifestyle-tools" exact render={() => <LifestyleTools />} />
          <Route path="/medical_notes_parking_lot" exact render={() => <MedicalNotesParkingLot />} />
          <Route path="/test-harness" exact render={() => <EditMetricsTestHarness />} />
          <Route path="/view-health-data-test-harness" exact render={() => <ViewHealthDataTestHarness />} />
          <Route path="/ai-chat-test-harness" exact render={() => <AIChatTestHarness />} />
          <Route path="/medical-data-viewer-test-harness" exact render={() => <MedicalDataViewerTestHarness />} />
          <Route path="/prevent-test-harness" exact render={() => <PreventCalculatorTestHarness />} />
          <Route path="/lifestyle-tools-test-harness" exact render={() => <LifestyleToolsTestHarness />} />
          <Route path="/medical-notes-parking-lot-test-harness" exact render={() => <MedicalNotesParkingLotTestHarness />} />
          <Route path="/hms_home" exact render={() => <HMSHome />} />
          <Route path="/hms-home-test-harness" exact render={() => <HMSHomeTestHarness />} />
          <Route path="/pii-washer" exact render={() => <PIIWasher />} />
          <Route path="/pii-washer-test-harness" exact render={() => <PIIWasherTestHarness />} />
          <Route render={() => <Redirect to="/" />} />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;
